import React, { Component } from 'react';
import fire, { auth, provider } from './fire';
import Header from './header';
import Hero from './hero';
import Search from './components/search';
import Video from './components/video';
import Trailers from './components/trailers';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      messages: [],
      user: null // <-- user authentication
    }; // <- set up react state
    this.login = this.login.bind(this); // <-- add this line
    this.logout = this.logout.bind(this); // <-- add this line    
  }

  handleChange(e) {
    /* ... */
  }
  logout() {
    auth.signOut()
      .then(() => {
        this.setState({
          user: null
        });
      });
  }
  login() {
    auth.signInWithPopup(provider) 
      .then((result) => {
        const user = result.user;
        this.setState({
          user
        });
      });
  }

  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user });
      } 
    });
  }

  componentWillMount(){
    /* Create reference to messages in Firebase Database */
    let messagesRef = fire.database().ref('messages').orderByKey().limitToLast(100);
    messagesRef.on('child_added', snapshot => {
      /* Update React state when message is added at Firebase Database */
      let message = { text: snapshot.val(), id: snapshot.key };
      this.setState({ messages: [message].concat(this.state.messages) });
    })
  }
  addMessage(e){
    e.preventDefault(); // <- prevent form submit from reloading the page
    /* Send the message to Firebase */
    fire.database().ref('messages').push( this.inputEl.value );
    this.inputEl.value = ''; // <- clear the input
  }

  render() {
    return (
      <div >
        <Header />
        <Video />
        <div className="container padding-2rem">

        <Hero />
        <Trailers />
        </div>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js